class RecoverController {
	constructor(AuthFactory, $filter, $rootScope, ngDialog, $state) {
		"ngInject";
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			vm.email = null;
		};

		vm.submit = () =>{
			AuthFactory.recoverPassword(AuthFactory.USER_TYPES.TEAM, vm.email).then(response =>{
				ngDialog.open({
					template: 'successTemplate',
					data: {
						message: $translate('RECOVER_SUCCESS')
					}
				});
				vm.email = null;
				$state.go('login');
			});
		}
	}
}

export default RecoverController;



// WEBPACK FOOTER //
// ./client/app/components/auth/recover/recover.controller.js